import {
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from '@material-ui/core';
import React from 'react';
import ReactJson, { ReactJsonViewProps } from 'react-json-view';

type Props = {
  data: any;
  shouldCollapse?: ReactJsonViewProps['shouldCollapse'];
  onEdit?: ReactJsonViewProps['onEdit'];
};

export const Json: React.FC<Props> = ({ data, shouldCollapse, onEdit }) => {
  if (data === undefined) {
    return <em>undefined</em>;
  }
  if (data === null) {
    return <em>null</em>;
  }
  return (
    <ReactJson
      src={data}
      name={null}
      theme="tomorrow"
      shouldCollapse={shouldCollapse}
      collapseStringsAfterLength={80}
      onEdit={onEdit}
      enableClipboard={false}
      displayDataTypes={false}
      displayObjectSize={false}
      style={{ padding: 16, width: '100%' }}
    />
  );
};

export const JsonDialogInner: React.FC<Props & { onClose: () => void }> = ({
  onClose,
  ...props
}) => {
  return (
    <>
      <DialogContent>
        <Json {...props} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </>
  );
};

export const JsonDialog: React.FC<
  Props & { open: boolean; onClose: () => void }
> = ({ open, ...props }) => {
  return (
    <Dialog
      open={open}
      onClose={props.onClose}
      maxWidth="xl"
      onClick={(ev) => ev.stopPropagation()}
    >
      <JsonDialogInner {...props} />
    </Dialog>
  );
};
